import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://bella-ceylon.onrender.com/api/public',
});

export const fetchData = async (endpoint, lang) => {
  try {
    const response = await apiClient.get(endpoint, {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw error.response?.data || new Error('An API error occurred');
  }
};